import * as React from 'react'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack';
import Draggable from 'react-draggable';
import Grid from '@mui/material/Grid';
import Badge from '@mui/material/Badge';
import Typography from '@mui/material/Typography';
import { useSelector, useDispatch } from 'react-redux';
import IconButton from '@mui/material/IconButton';
import { BorderLinearProgress } from './CustomProgressbars';
import { Close, CloseFullscreenRounded, OpenInFullRounded } from '@mui/icons-material';


function TransferWindow({ children }) {
    const [draggableWindow, setDraggableWindow] = React.useState(false);
    const [minimize, setMinimize] = React.useState(false);

    // React.useEffect(() => {
    //     const timer = setInterval(() => {
    //         setProgress((prevProgress) => (prevProgress >= 100 ? 10 : prevProgress + 10));
    //     }, 800);
    //     return () => {
    //         clearInterval(timer);
    //     };
    // }, []);


    const isBackgroundTaskOpen = useSelector(({
        utilities: { isBackgroundTaskOpen }
    }) => (isBackgroundTaskOpen));
    const openWindow = React.useCallback(() => {
        return isBackgroundTaskOpen
    }, [isBackgroundTaskOpen])

    const pendingTasks = useSelector(state => state.utilities.pendingTasks)
    const totalTasks = useSelector(state => state.utilities.totalTasks)
    const completeTasks = useSelector(state => state.utilities.completeTasks)
    const failedTasks = useSelector(state => state.utilities.failedTasks)

    const getProgress = React.useCallback(() => {
        const percentage = totalTasks > 0 ? (completeTasks / totalTasks) * 100 : 0;
        return percentage;
    }, [completeTasks, totalTasks])
    const dispatch = useDispatch();


    const setDrag = () => {
        if (!draggableWindow) {
            setDraggableWindow(true);
        }
    }
    const unSetDrag = () => {
        if (draggableWindow) {
            setDraggableWindow(false)
        }

    }
    const childrenWithProps = React.Children.map(children, child => {
        // Checking isValidElement is the safe way and avoids a typescript
        // error too.
        return React.cloneElement(child, { setDrag, unSetDrag });

    });

    return (
        <Draggable
            disabled={draggableWindow}
            bounds="html"
        >
            <Box sx={{
                overflowY: "none",
                overscrollBehavior: "contain",
                bgcolor: '#060606b3',
                borderRadius: '.5em',
                minHeight: openWindow() ? minimize ? "35px" : '400px' : 0,
                maxHeight: openWindow() ? minimize ? "35px" : 'max-content' : 0,
                transition: "opacity .15s ease-out",
                opacity: openWindow() ? 1 : 0,
                overflow: openWindow() ? 'auto' : "hidden",
                minWidth: "400px",
                width: openWindow() ? '400px' : 0,
                resize: 'both',
                position: 'absolute',
                bottom: 100,
                right: 100,
                padding: 0,
                boxShadow: 3,
                zIndex: 100000,
                pb: minimize ? 0 : 1
            }} direction='vertical'>
                <Stack direction='column' sx={{ minWidth: '100%' }}>
                    <Grid container
                        sx={{
                            // height: '100%',
                            pl: 2,
                            pr: .5,
                            width: '100%',
                            bgcolor: '#06060661',
                            borderRadius: '.5em',
                            pb: minimize ? 0 : 1
                        }}
                        // onMouseOver={() => unSetDrag()} 
                        direction="row"
                    >
                        <Grid item xs={4} sx={{ mt: minimize ? .5 : 1 }}>
                            <Badge color='error'
                                badgeContent={failedTasks}
                                sx={{
                                    "& .MuiBadge-badge": {
                                        width: minimize ? 15 : 20,
                                        height: minimize ? 15 : 20,
                                        fontSize: 10
                                    }
                                }}
                            >
                                <Typography
                                    variant={minimize ? 'body2' : 'body2'}
                                    noWrap
                                    sx={{
                                        fontFamily: 'quicksand',
                                        flexGrow: 1,
                                        color: 'white'
                                    }}
                                >
                                    Background Tasks
                                </Typography>

                            </Badge>
                        </Grid>
                        <Grid item xs={6} sx={{ mt: minimize ? 1 : 1.5 }}>
                            {pendingTasks > 0 && (
                                <BorderLinearProgress
                                    progressHeight={minimize ? 3 : 5}
                                    progressBorderRadius={minimize ? 3 : 5}
                                    value={getProgress()}
                                />)
                            }
                        </Grid>
                        <Grid item xs={2} sx={{ paddingTop: minimize ? .1 : .5, paddingLeft: 1 }}
                        >
                            <Stack direction="row" justifyContent="flex-end" spacing={1}>
                                <IconButton
                                    edge="end"
                                    aria-label="minimize"
                                    aria-controls="1"
                                    aria-haspopup="true"
                                    onClick={() => setMinimize(!minimize)}
                                    sx={{
                                        '& .MuiSvgIcon-root': {
                                            width: minimize ? '.6em' : '.8em',
                                            height: '.8em',
                                            color: 'white'
                                        }
                                    }}
                                >
                                    {minimize ? <OpenInFullRounded /> : <CloseFullscreenRounded />}
                                </IconButton>
                                <IconButton
                                    edge="end"
                                    aria-label="minimize"
                                    aria-controls="1"
                                    aria-haspopup="true"
                                    onClick={() => dispatch({ type: 'CLOSE_BACKGROUND_TASK_MODAL' })}
                                    sx={{
                                        '& .MuiSvgIcon-root': {
                                            width: minimize ? '.6em' : '.8em',
                                            height: '.8em',
                                        }
                                    }}
                                    color='error'
                                >
                                    <Close />
                                </IconButton>
                            </Stack>
                        </Grid>
                    </Grid>
                    <Box display={minimize ? 'none' : 'inherit'} sx={{ bgcolor: "#0000000a" }}>
                        {childrenWithProps}
                    </Box>
                </Stack>
            </Box>
        </Draggable >
    )
}

export default TransferWindow